/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsReturnStep: {
  name: 'return-step';
  data: string;
} = {
  name: 'return-step',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M18 8c0-1.648-1.881-2.589-3.2-1.6l-5.333 4c-.19.142-.345.309-.467.492V7a1 1 0 0 0-2 0v10a1 1 0 1 0 2 0v-3.892a2 2 0 0 0 .467.492l5.333 4c1.319.989 3.2.048 3.2-1.6V8Zm-7.333 4L16 8v8l-5.333-4Z" fill="currentColor"/></svg>`,
};
